module.exports = __webpack_public_path__ + "img/Quotable 3.9fdc85ba.svg";